import script from "./MonitoringCamera.vue?vue&type=script&setup=true&lang=js"
export * from "./MonitoringCamera.vue?vue&type=script&setup=true&lang=js"

import "./MonitoringCamera.vue?vue&type=style&index=0&id=56bc533a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-56bc533a"]])

export default __exports__